module.exports = __webpack_public_path__ + "img/turnback.13a098bc.png";